export default {
  data() {
    return {
      form: {},
      isDifferentDeliveryAddress: false,
      validation: {},
    };
  },
  methods: {
    initForm() {
      this.form = {
        shipping_first_name: '',
        shipping_last_name: '',
        shipping_address_street: '',
        shipping_address_house_number: '',
        shipping_address_zip: '',
        shipping_address_city: '',
        shipping_address_country: '',
      };
    },
    initProfileData() {
      this.isDifferentDeliveryAddress = !!parseInt(this.user.is_different_delivery_address);
      this.form = {
        is_different_delivery_address: this.user.is_different_delivery_address,
        shipping_first_name: this.user.shipping_first_name,
        shipping_last_name: this.user.shipping_last_name,
        shipping_address_street: this.user.shipping_address_street,
        shipping_address_house_number: this.user.shipping_address_house_number,
        shipping_address_zip: this.user.shipping_address_zip,
        shipping_address_city: this.user.shipping_address_city,
        shipping_address_country: this.user.shipping_address_country,
      };
    },
    initValidation() {
      this.validation = {
        shipping_first_name: {
          valid: null,
          message: '',
        },
        shipping_last_name: {
          valid: null,
          message: '',
        },
        shipping_address_street: {
          valid: null,
          message: '',
        },
        shipping_address_house_number: {
          valid: null,
          message: '',
        },
        shipping_address_zip: {
          valid: null,
          message: '',
        },
        shipping_address_city: {
          valid: null,
          message: '',
        },
        shipping_address_country: {
          valid: null,
          message: '',
        },
      };
    },
    onSubmit() {
      this.initValidation();

      if (!this.isDifferentDeliveryAddress) {
        this.initForm();
      }

      this.form.is_different_delivery_address = this.isDifferentDeliveryAddress ? '1' : '0';
      this.updateDeliveryAddress(this.form);
    },
  },
  created() {
    this.initValidation();
    this.initForm();
    this.initProfileData();
  },
};
